class Clock {
    date: Date;
    clockElement: HTMLElement;
    timer: any;
    currentClock: string;

    constructor(selector: string) {
        this.clockElement = document.querySelector(selector)
        if (this.clockElement) this.init()
    }

    init() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.play()
                }
                else {
                    this.stop()
                }
            })
        })

        observer.observe(this.clockElement);
    }

    play() {
        this.timer = setInterval(() => {
            this.update()
        }, 1000)
    }

    stop() {
        if (this.timer) clearInterval(this.timer)
    }

    update() {
        let nwHour = new Date().getHours();
        let nwMinute = `${new Date().getMinutes() < 10 ? '0' : ''}` + new Date().getMinutes();
        let nwClock = `${nwHour}:${nwMinute}`
        if (this.currentClock != nwClock) {
            this.currentClock = `${nwHour}:${nwMinute}`
            this.clockElement.innerHTML = this.currentClock
        }
    }

}

new Clock('.trnz-clock')